import styled from 'styled-components'
import { XButton } from '../../components/Button'
import { useVipInfo } from '../../context/VipInfoContext'
import useCopyClipboard from '../../hooks/useCopy'
import { DialogType, useDialog } from '../../context/DialogContext'
import { formatUnits } from 'ethers/lib/utils'

export default function Invitation() {
  const info = useVipInfo()
  const link = `${window.location.origin}/account?refer=${info.name}`
  const [, copy] = useCopyClipboard()
  const { open } = useDialog()
  return (
    <InvitationWrapper>
      <Title>My personal invitation link</Title>
      <SubTitle>Personal invitation link : </SubTitle>
      <InvitationCodeWrapper>
        <InvitationLink>{link}</InvitationLink>
        <XButton
          onClick={() => {
            copy(link)
            open(DialogType.Success, { title: 'Copy Success!' })
          }}
        >
          Copy
        </XButton>
      </InvitationCodeWrapper>
      <InvitationTipsWrapper>
        <p>
          Remaining memberships: <span>{info.maxRegisterCount - info.soldRegisterCount}</span>
        </p>
        <p>
          Current price: <span>{+formatUnits(info.registerFee)} COCOS</span>/member
        </p>
        {/*<p>Maximum rewards for one person <span>50,000 COCOS</span></p>*/}
      </InvitationTipsWrapper>
      <RulesWrapper>
        Invitation rules:
        <br />
        1. COCOS: 10% of the membership fee used as a rebate reward
        <br />
        - Without Inviter: 10% back to the system.
        <br />
        - With Inviter: 8% to first-level inviter, 2% to second-level inviter.
        <br />
        2. Launchpad: 1% of purchased amount used as rebate reward
        <br />
        - Without Inviter: 1% back to the system
        <br />- With Inviter: 0.8% for first-level inviter and 0.2% for second-level inviter
      </RulesWrapper>
    </InvitationWrapper>
  )
}

const InvitationWrapper = styled.div`
  width: 565px;
  height: 447px;
  border-radius: 20px;
  background: #11388c;
  border-radius: 20px;
  position: relative;
  padding: 27px 38px;
`

const Title = styled.h3`
  line-height: 33px;
  color: #fff;
  font-size: 28px;
`
const SubTitle = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: #74a0ff;
  margin-top: 28px;
`

const InvitationCodeWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 45px;
  margin-top: 10px;
`
const InvitationLink = styled.span`
  display: inline-block;
  width: 382px;
  height: 45px;
  border-radius: 9px;
  background: #fff;
  line-height: 45px;
  padding: 0 12px;
  color: #b3b3b3;
  font-size: 14px;
`

const InvitationTipsWrapper = styled.div`
  width: 100%;
  height: 98px;
  margin-top: 15px;
  border-radius: 6px;
  background: #133e9c;
  padding-top: 14px;
  padding-left: 16px;
  p {
    font-size: 13px;
    color: #6090f8;
    position: relative;
    height: 18px;
    line-height: 18px;
    margin-bottom: 8px;
    padding-left: 1em;
    &::before {
      content: '*';
      position: absolute;
      left: 0;
    }
    span {
      color: #ffd244;
    }
  }
`

const RulesWrapper = styled.div`
  margin-top: 17px;
  font-size: 13px;
  line-height: 18px;
  color: #6090f8;
  white-space: pre;
`
